import CodeHighlight from 'dashboard/components-lib/CodeHighlight';
import { Report } from 'dashboard/models/report';

interface ReportInputIntegrationProps {
  report: Report;
  isRedacted: boolean;
}

const ReportInputIntegration = ({ report, isRedacted }: ReportInputIntegrationProps) => {
  if (isRedacted) {
    return <></>;
  }
  return (
    <CodeHighlight language='json' rowsToShow={10} light={true}>
      {JSON.stringify((report.attributes as any)?.query)}
    </CodeHighlight>
  );
};

export default ReportInputIntegration;
